"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Content = _interopRequireDefault(require("@insided/deprecated-preact-components/common/Content"));

var _htmlSanitizer = require("../html-sanitizer");

var _Create = require("../Create.utils");

var _excluded = ["content", "template", "isolatedContent", "status"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var WindowEmailPreview = function WindowEmailPreview(_ref) {
  var subject = _ref.subject,
      previewText = _ref.previewText,
      children = _ref.children,
      fromUsername = _ref.fromUsername,
      fromEmail = _ref.fromEmail,
      onSubjectClick = _ref.onSubjectClick;
  return (0, _preact.h)("div", {
    className: "create-email-campaign__preview"
  }, (0, _preact.h)("div", {
    className: "create-email-campaign__preview-header"
  }, (0, _preact.h)("div", {
    className: "circle circle--red"
  }), (0, _preact.h)("div", {
    className: "circle circle--orange"
  }), (0, _preact.h)("div", {
    className: "circle circle--green"
  })), (0, _preact.h)("div", {
    className: "create-email-campaign__preview-subject",
    onClick: onSubjectClick
  }, (0, _preact.h)("div", null, "Subject"), subject ? (0, _preact.h)("div", {
    className: "create-email-campaign__preview-input"
  }, (0, _preact.h)("div", {
    dangerouslySetInnerHTML: {
      __html: subject
    }
  })) : (0, _preact.h)("div", {
    className: "create-email-campaign__preview-placeholder"
  }, "Enter email subject")), (0, _preact.h)("div", {
    className: "create-email-campaign__preview-preview",
    onClick: onSubjectClick
  }, (0, _preact.h)("div", null, "Preview text"), previewText ? (0, _preact.h)("div", {
    className: "create-email-campaign__preview-input"
  }, (0, _preact.h)("div", {
    dangerouslySetInnerHTML: {
      __html: previewText
    }
  })) : (0, _preact.h)("div", {
    className: "create-email-campaign__preview-placeholder"
  }, "Enter preview text")), (0, _preact.h)("div", {
    className: "create-email-campaign__preview-from"
  }, (0, _preact.h)("div", null, "From"), (0, _preact.h)("div", {
    className: "create-email-campaign__preview-input"
  }, fromUsername), (0, _preact.h)("div", {
    className: "create-email-campaign__preview-meta"
  }, "\xA0<", fromEmail, " via amazonses.com>")), children);
};

var resetStyles = "\n<style>\n  html, body { \n    margin: 0\n  }\n  input-variable {\n    background-color: #F4F5F6;\n    border: 1px solid #9599A2;\n    border-radius: 4px;\n    color: #9599A2;\n    display: inline-block;\n    font-family: Roboto, \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    font-size: 12px;\n    font-weight: 400;\n    height: 20px;\n    line-height: 1.5;\n    padding: 0 6px;\n  }\n\n  img { max-width: 100%; }\n  table {\n    line-height: 1.5\n  }\n </style>\n";
var DEFAULT_HEIGHT = 225;

var IframeWithAutoHeight = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(IframeWithAutoHeight, _Component);

  var _super = _createSuper(IframeWithAutoHeight);

  function IframeWithAutoHeight() {
    var _this;

    (0, _classCallCheck2.default)(this, IframeWithAutoHeight);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "iframeRef", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      height: DEFAULT_HEIGHT
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleIframeLoad", function () {
      setTimeout(function () {
        var _this$iframeRef$curre, _this$iframeRef$curre2, _body$scrollHeight;

        var body = (_this$iframeRef$curre = _this.iframeRef.current) === null || _this$iframeRef$curre === void 0 ? void 0 : (_this$iframeRef$curre2 = _this$iframeRef$curre.contentWindow) === null || _this$iframeRef$curre2 === void 0 ? void 0 : _this$iframeRef$curre2.document.body;
        var iframeHeight = (_body$scrollHeight = body === null || body === void 0 ? void 0 : body.scrollHeight) !== null && _body$scrollHeight !== void 0 ? _body$scrollHeight : DEFAULT_HEIGHT;

        _this.setState({
          height: iframeHeight
        });
      }, 10);
    });
    return _this;
  }

  (0, _createClass2.default)(IframeWithAutoHeight, [{
    key: "render",
    value: function render() {
      var content = this.props.content;
      return (0, _preact.h)("iframe", {
        ref: this.iframeRef,
        srcDoc: resetStyles + content,
        onLoad: this.handleIframeLoad,
        style: {
          width: '100%',
          height: this.state.height,
          border: 0
        }
      });
    }
  }]);
  return IframeWithAutoHeight;
}(_preact.Component);

var CreateEmailPreview = function CreateEmailPreview(_ref2) {
  var content = _ref2.content,
      template = _ref2.template,
      isolatedContent = _ref2.isolatedContent,
      status = _ref2.status,
      props = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  var sanitizeProps = {
    allowedSchemas: ['', '#', 'http', 'https', 'mailto'],
    noWrapper: true
  };
  var templeWithContent = (0, _Create.getTemplateWithContent)(content, template, status);
  var sanitizedEmail = (0, _htmlSanitizer.sanitize)(templeWithContent, undefined, sanitizeProps);
  return (0, _preact.h)(WindowEmailPreview, props, isolatedContent ? (0, _preact.h)(IframeWithAutoHeight, {
    content: sanitizedEmail
  }) : (0, _preact.h)(_Content.default, {
    content: sanitizedEmail,
    className: "post__content--email"
  }));
};

var _default = CreateEmailPreview;
exports.default = _default;